import { Plugin } from '@ckeditor/ckeditor5-core';
import { createDropdown, addListToDropdown, Model, SplitButtonView } from '@ckeditor/ckeditor5-ui';
import { Collection } from '@ckeditor/ckeditor5-utils';
import recordIcon from '../ckeditor5-recorder/theme/icons/recordaudio.svg';
import audioIcon from '../ckeditor5-toolbar-custom/theme/icons/audioIcon.svg';
import uploadIcon from '../ckeditor5-audio/theme/icons/audio.svg';

export default class AudioMenu extends Plugin {
	init() {
		const editor = this.editor;

		editor.ui.componentFactory.add('audioMenu', locale => {
			// Crear el dropdown
			const dropdownView = createDropdown(locale, SplitButtonView);

			// Configurar el botón principal (acción)
			const actionView = dropdownView.buttonView.actionView;
			actionView.set({
				label: 'Insertar audio',
				icon: audioIcon,
				tooltip: 'Insertar audio'
			});

			// Acción principal → subir audio directamente
			actionView.on('execute', () => {
				editor.execute('uploadAudio');
				editor.editing.view.focus();
			});

			// Crear submenú (dropdown items)
			const items = [
				{ command: 'uploadAudio', label: 'Subir audio', icon: uploadIcon },
				{ command: 'recordAudio', label: 'Grabar audio', icon: recordIcon }
			];

			const itemDefinitions = new Collection();

			for (const item of items) {
				const model = new Model({
					command: item.command,
					label: item.label,
					withText: true,
					icon: item.icon
				});
				itemDefinitions.add({ type: 'button', model });
			}

			addListToDropdown(dropdownView, itemDefinitions);

			// Ejecutar comando al hacer clic en el submenú
			this.listenTo(dropdownView, 'execute', evt => {
				const commandName = evt.source.command;
				if (commandName) {
					editor.execute(commandName);
					editor.editing.view.focus();
				}
			});

			// Estilo visual igual al de imagen
			dropdownView.extendTemplate({
				attributes: {
					class: ['ck-splitbutton', 'ck-audio-splitbutton']
				}
			});

			return dropdownView;
		});
	}
}
